import React from 'react';
import { WarningCircle, PaperPlaneTilt, CheckCircle } from 'phosphor-react';
import { Button } from '@material-ui/core';

import styles from '../../../../styles/sass/components/Dashboard.module.scss';

interface ComponentProps {
  icon: 'warning' | 'paperPlane' | 'success';
  title: string;
  info?: string;
  buttonText?: string;
  onClick?: React.MouseEventHandler;
}
function VerificationContent({
  icon,
  title,
  info,
  buttonText,
  onClick,
}: ComponentProps) {
  return (
    <React.Fragment>
      <div style={{ display: 'inherit', alignItems: 'inherit' }}>
        {icon === 'warning' ? (
          <WarningCircle
            size={32}
            color="#826441"
            style={{ margin: '0 15px 0 0' }}
          />
        ) : icon === 'paperPlane' ? (
          <PaperPlaneTilt
            size={32}
            color="#826441"
            style={{ margin: '0 15px 0 0' }}
          />
        ) : (
          <CheckCircle
            weight="fill"
            size={32}
            color="#195A50"
            style={{ margin: '0 15px 0 0' }}
          />
        )}
        <div>
          <h2 className={styles.verifyText}>{title}</h2>
          {info && <p className={styles.verifyInfo}>{info}</p>}
        </div>
      </div>
      {onClick && buttonText && (
        <Button onClick={onClick} className={styles.verifyButton}>
          {buttonText}
        </Button>
      )}
    </React.Fragment>
  );
}
export default VerificationContent;
